export const CHAT_IDENTITY_ENDPOINT = '/c/v1/identity';
